var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonetizationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66666C5.40002 1.66666 1.66669 5.4 1.66669 10C1.66669 14.6 5.40002 18.3333 10 18.3333C14.6 18.3333 18.3334 14.6 18.3334 10C18.3334 5.4 14.6 1.66666 10 1.66666ZM11.175 15.075V16.6667H8.95002V15.0583C7.52502 14.7583 6.31669 13.8417 6.22502 12.225H7.85835C7.94169 13.1 8.54169 13.7833 10.0667 13.7833C11.7 13.7833 12.0667 12.9667 12.0667 12.4583C12.0667 11.7667 11.7 11.1167 9.84169 10.675C7.77502 10.175 6.35835 9.325 6.35835 7.61666C6.35835 6.18333 7.51669 5.25 8.95002 4.94166V3.33333H11.175V4.95833C12.725 5.33333 13.5 6.50833 13.55 7.78333H11.9167C11.875 6.85833 11.3834 6.225 10.0667 6.225C8.81669 6.225 8.06669 6.79166 8.06669 7.59166C8.06669 8.29166 8.60835 8.75 10.2917 9.18333C11.975 9.61666 13.775 10.3417 13.775 12.4417C13.7667 13.9667 12.625 14.8 11.175 15.075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationOn);
export default __webpack_public_path__ + "static/media/monetization-on.609136cd8952f5795e1acdb120f8f313.svg";
export { ForwardRef as ReactComponent };